<template>
  <div>
    <div class="status" v-if="!firebase_connected">
      <span class="icon"><i class="fas fa-exclamation-triangle"></i></span> CURRENTLY DISCONNECTED
    </div>
    <div id="app" class="container">
      <transition name="fade"> 
        <div v-if="status_message" :class="status_message_type" class="notification is-light is-large">
          <button class="delete" @click="clearStatus"></button>
          {{ status_message }}
        </div>
      </transition>
      <transition name="fade">
        <div v-if="updateExists" class="is-info notification ss-large">
          <p class="content mb-2">A new version of the app is available.</p>
          <button @click="refreshApp" class="button is-info is-light"> Click to update </button>
        </div>
      </transition>
      <router-view></router-view>

      <div v-if="debug" class="box mx-2">
        <strong>Dabug</strong>
        <dl v-if="current_user">
          <dt>str.crnt_usr.uid</dt> <dd>:  {{ current_user.uid }}</dd>
          <dt>str.crnt_usr.isAnonymous</dt> <dd>:  {{ current_user.isAnonymous }}</dd>
          <template v-if="current_user.providerData && current_user.providerData.length > 0">
            <dt>str.crnt_usr.prvdrDta</dt> <dd>:  {{ current_user.providerData[0].displayName }}</dd>
          </template>
          <dt>Test</dt><dd>Do we have a new version?</dd>
        </dl>
        
      </div>
      <div class="footer has-text-right">
        <p>The Bad Driver Club (<a :href="'/update/'+new Date().getTime()">v{{version}}</a>)</p>
        <p>
          <router-link to="/">Home</router-link> | 
          <router-link to="/about">About</router-link> | 
          <router-link to="/privacy">Privacy</router-link> | 
          <span v-if="current_user && !current_user.isAnonymous">
            <router-link to="/login">Profile </router-link> | 
            <router-link to="/logout">Logout </router-link>
          </span>
          <router-link v-else-if="current_user && current_user.isAnonymous" to="/login">Login</router-link> 
          <span v-if="current_user && current_user.uid == 'jpbEIFWArCQ2nkVNE2BHR9XQ3Up1'">| <router-link to="/admin">Admin</router-link></span>
        </p>
        
      </div>
    </div>
  </div>
  
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import firebase from "firebase/app";

export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION || '0',
      firebase: firebase,
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  computed: {
    ...mapGetters({
      status_message: 'status_message', 
      status_message_type: 'status_message_type',
      current_user: 'current_user',
      firebase_connected: 'firebase_connected',
    }),
    debug() {
      return process.env.NODE_ENV === 'development'
    }
  },
  methods: {
    ...mapActions({
      clearStatus: 'clearStatus'
    }),
    showRefreshUI (e) {
      console.log("We have an update!",e)
      this.registration = e.detail;
      this.updateExists = true;
    },
    refreshApp () {
      console.log("Installing update")
      this.updateExists = false;
      if (this.registration && this.registration.waiting) { 
        this.registration.waiting.postMessage('skipWaiting');
      } else {
        console.log("service worker already ready");
        window.location.reload();
      }
    },
  },
  created () {
    document.addEventListener(
      'swUpdated', this.showRefreshUI,  { once: true }
    );
    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        console.log("Loading")
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      }
    );
  },
}
</script>

<style lang="css" scoped>
  .fade-enter { opacity: 0; }
  .fade-enter-active { transition: opacity 1s; }
  .fade-leave-active { opacity: 0; transition: opacity 1s; }

  dl dt { font-weight: bold; float: left; clear:left; }
  dl dd { float: left; font-style: italic;}

  

</style>